<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="role-body custom-form">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="form"
          label-position="top"
        >
          <el-form-item label="字典名称" prop="dictLabel">
            <el-input
              v-model="form.dictLabel"
              clearable
              autocomplete="off"
              placeholder="请输入字典名称"
              maxlength="100"
            />
          </el-form-item>
          <el-form-item label="字典编号" prop="dictCode">
            <el-input
              v-model="form.dictCode"
              clearable
              autocomplete="off"
              placeholder="请输入字典编号"
              maxlength="100"
            />
          </el-form-item>
          <el-form-item label="排序" prop="dictSort">
            <el-input-number
              v-model="form.dictSort"
              :precision="0"
              :min="0"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { addDictInfo, editDictInfo } from "./api";
export default {
  name: "DictItemAddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        show: false,
        title: "添加角色",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        dictCode: "",
        dictLabel: "",
        dictSort: 0,
        dictType: "",
        dictDataId: "",
      },
      rules: {
        dictLabel: [{ required: true, message: "字典名称不能为空" }],
        dictCode: [{ required: true, message: "字典编号不能为空" }],
      },
    };
  },
  methods: {
    init(type, row) {
      if (!!row) {
        this.dialogObj.title = "编辑字典";
        this.form = Object.assign({}, row);
      } else {
        this.form.dictType = type;
        this.dialogObj.title = "添加字典";
      }
      this.dialogObj.show = true;
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodName = "";
          if (this.form.dictDataId) {
            methodName = editDictInfo;
          } else {
            methodName = addDictInfo;
          }
          const par = {
            dictCode: this.form.dictCode,
            dictLabel: this.form.dictLabel,
            dictSort: this.form.dictSort,
            dictType: this.form.dictType,
            dictDataId: this.form.dictDataId,
          };
          methodName(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.dictDataId ? "编辑成功" : "保存成功"
                );
                this.$parent.getTableData();
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.role-body {
  padding: 0 0.6rem;
  box-sizing: border-box;
}
</style>
